/**
 * For the pages an email's sealed link opens (B6-7). The token stays in the address the person
 * opened; the pages read it from there and keep it out of their own slices. It stays in the router's
 * location in the store, which is only in this browser's memory: these pages carry no analytics.
 */

/** The link's token in a location's search, or null. */
export const tokenFrom = search => new URLSearchParams(search || '').get('token') || null;

// Our API's refusal, read from an axios error or from `post`'s, which copies the body onto it
const errorCode = e => e?.response?.data?.error?.code || e?.error?.code || null;

/** True when the server said the link isn't good, not that something else went wrong. */
export const isBadLink = e => errorCode(e) === 'invalid-input';

/** True when the server refused: the address may have stopped (S3-20), so ask it again. */
export const isRefused = e => errorCode(e) === 'forbidden';
